import { render, staticRenderFns } from "./CompanyLicenseSetting.vue?vue&type=template&id=385efa5a"
import script from "./CompanyLicenseSetting.vue?vue&type=script&lang=js"
export * from "./CompanyLicenseSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports